import Typography from "@mui/material/Typography";
import {
  Grid,
  IconButton,
  TextField,
  LinearProgress,
  Card,
  CardContent,
} from "@mui/material";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import ResponsiveDataGrid from "../../../../../components/MobileList/ResponsiveDataGrid";
import { BiTrash, BiEdit } from "react-icons/bi";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SubCategories,
  setSearchBody,
} from "../../../../../app/slices/subcategorySlice";
import ConfirmationDialog from "../../../../../helpers/ConfirmationDialog";
import { SelectProvince } from "../../../../../components/Selectors/SelectProvince";
import Permission from "../../../../../components/userPermission/userPermission";

const SubCategoriesTabel = () => {
  const [search, setSearch] = useState({
    search: "",
    province_id: null,
  });
  const [page, setPage] = useState(15);
  const dispatch = useDispatch();
  const subCategory = useSelector((state) => state.subCategories.subCategory);
  const _SearchBody = useSelector((state) => state.subCategories.searchBody);
  const _provinces = useSelector((state) => state.provinces.provinces.data);

  const [openConfirm, setConfirmOpen] = useState(false);
  const [dialogData, setDialogData] = useState("");

  const handleDeleteClick = (params) => {
    setConfirmOpen(true);
    setDialogData(params);
  };

  const handleConfirmDelete = () => {
    dispatch(SubCategories.deleteById(dialogData.id, _SearchBody));
    setConfirmOpen(false);
  };

  const handleCancelDelete = () => {
    setConfirmOpen(false);
  };

  const columns = [
    {
      field: "name",
      headerName: "الاسم",
      flex: 1,
    },
    {
      field: "items_count",
      headerName: "العدد",
      flex: 1,
    },
    {
      field: "category",
      headerName: "الصفحة الرئيسية",
      flex: 1,
      renderCell: (params) => {
        return <Typography>{params.row.category.name}</Typography>;
      },
    },
    {
      field: "provinces",
      headerName: "عدد المحافظات",
      flex: 1,
      renderCell: (params) =>
        params.row.provinces?.length === 0
          ? "كل المحافظات"
          : params.row.provinces?.length,
    },
    {
      field: "logo",
      headerName: "الصورة",
      flex: 1,
      renderCell: (params) => {
        return (
          <Box component="img" src={params.row.logo} sx={{ height: 90 }} />
        );
      },
    },
    {
      field: "operations",
      headerName: "العمليات",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <Permission permission="sub_category_edit">
              <IconButton
                onClick={() => dispatch(SubCategories.getById(params.row.id))}
              >
                <BiEdit />
              </IconButton>
            </Permission>
            <Permission permission="sub_category_delete">
              <IconButton onClick={() => handleDeleteClick(params.row)}>
                <BiTrash />
              </IconButton>
            </Permission>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(
        SubCategories.getAll({
          search: search.search,
          province_id: search.province_id ?? "",
          skip: 0,
          take: 15,
        })
      );
      dispatch(
        setSearchBody({
          search: search.search,
          province_id: search.province_id ?? "",
          skip: 0,
          take: 15,
        })
      );
    }, 500);
    return () => clearTimeout(timeout);
  }, [dispatch, search]);

  return (
    <Card>
      <CardContent>
        <Box>
          <ConfirmationDialog
            open={openConfirm}
            title="تاكيد"
            message="هل انت متاكد من حذف"
            name={dialogData.name}
            confirmText="حذف"
            cancelText="الغاء"
            onConfirm={() => handleConfirmDelete()}
            onCancel={handleCancelDelete}
          />
        </Box>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={12} md={2}>
            <TextField
              size="small"
              onChange={(e) => {
                setSearch({
                  ...search,
                  search: e.target.value,
                });
              }}
              label="بحث عن الاسم "
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={2.5}>
            <SelectProvince
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  province_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _provinces?.filter((x) => x.id === search.province_id)[0] ??
                null
              }
            />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ height: { xs: "auto", md: "70vh" }, width: "100%" }}>
              {subCategory.data ? (
                <ResponsiveDataGrid gridHeight={null}
                  rows={subCategory.data}
                  columns={columns}
                  pageSize={page}
                  rowCount={subCategory.total}
                  loading={subCategory.loading}
                  rowHeight={100}
                  pagination
                  paginationMode="server"
                  selectionModel={[]}
                  onPageChange={(newPage) =>
                    dispatch(
                      SubCategories.getAll({
                        search: search,
                        skip: newPage * 15,
                        take: 15,
                      })
                    )
                  }
                  rowsPerPageOptions={[15, 25, 50, 100]}
                  onPageSizeChange={(newPageSize) => {
                    dispatch(
                      SubCategories.getAll({
                        search: search,
                        skip: 0,
                        take: newPageSize,
                      })
                    );
                    setPage(newPageSize);
                  }}
                  components={{
                    LoadingOverlay: LinearProgress,
                  }}
                />
              ) : (
                <LinearProgress />
              )}
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default SubCategoriesTabel;
